import { takeLatest, put, call, take } from "redux-saga/effects";
import {  
    QUESTION_TEMPLATE_GET_DATA, QUESTION_TEMPLATE_GET_DATA_API,  
    QUESTION_TEMPLATE_GET_DETAILS_DATA, QUESTION_TEMPLATE_GET_DETAILS_DATA_API,
    QUESTION_TEMPLATE_FORM_ADD_DATA, QUESTION_TEMPLATE_FORM_POST_API,
    QUESTION_TEMPLATE_FORM_UPDATE_DATA, QUESTION_TEMPLATE_FORM_PUT_API,
    
} from './Constants'
import {
    setQuestionTemplateDataSuccess, setQuestionTemplateDataFail,
    setQuestionTemplateDetailsDataSuccess, setQuestionTemplateDetailsDataFail,
    setQuestionTemplateFormAddDataSuccess ,setQuestionTemplateFormAddDataFail,
    setQuestionTemplateFormUpdateDataSuccess, setQuestionTemplateFormUpdateDataFail,
} from './Actions'
import { addErrorAlert, addSuccessAlert } from "../../../alert/Actions";
import { ticketApi } from "../../../../shared/components/Service";

function* getQuestionTemplateDataService() {
  try {
    const getQuestionTemplateDataResponse = yield call(ticketApi.get, QUESTION_TEMPLATE_GET_DATA_API);
    const status = getQuestionTemplateDataResponse.status;
    if (status === 200) {
      const data = getQuestionTemplateDataResponse.data.data;
      yield put(setQuestionTemplateDataSuccess(data));
    } else {
      yield put(setQuestionTemplateDataFail(getQuestionTemplateDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setQuestionTemplateDataFail(error));
  }
}

function* getQuestionTemplateDetailsDataService({id}) {
  try {
    const getQuestionTemplateDetailsDataResponse = yield call(ticketApi.getDetail, QUESTION_TEMPLATE_GET_DETAILS_DATA_API + id);
    const status = getQuestionTemplateDetailsDataResponse.status;
    if (status === 200) {
      const data = getQuestionTemplateDetailsDataResponse.data.data;
      yield put(setQuestionTemplateDetailsDataSuccess(data));
    } else {
      yield put(setQuestionTemplateDetailsDataFail(getQuestionTemplateDetailsDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setQuestionTemplateDetailsDataFail(error));
  }
}

function* postQuestionTemplateFormDataService({ request }) {
  try {
    const response = yield call(ticketApi.post,  QUESTION_TEMPLATE_FORM_POST_API ,request);
    const status = response?.status;
    const apiData = response?.data || response;

    // SUCCESS → if API returns 200 or 201
    if (status === 200 || status === 201 || apiData?.success) {
      yield put(addSuccessAlert(apiData.msg || "Question Template Created"));
      yield put(setQuestionTemplateFormAddDataSuccess(apiData.data));
      return;
    }

    // FAIL CASE (API returned non-success status)
    yield put(addErrorAlert(apiData.msg || "Error adding Question Template"));
    yield put(setQuestionTemplateFormAddDataFail(apiData.msg));
  } catch (error) {
    // SERVER/NETWORK ERROR
    const msg =
      error?.response?.data?.msg ||
      error?.message ||
      "Error adding Question Template";

    yield put(addErrorAlert(msg));
    yield put(setQuestionTemplateFormAddDataFail(msg));
  }
}

function* putQuestionTemplateFormDataService({ id, request }) {
  try {
    const response = yield call(
      ticketApi.put,
      QUESTION_TEMPLATE_FORM_PUT_API + id,
      request,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      yield put(addSuccessAlert("Question Template updated"));
      yield put(setQuestionTemplateFormUpdateDataSuccess(response.data.data));
    }
  } catch (error) {
    // Extract backend message safely
    const backendMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      "Could not update Question Template";

    yield put(addErrorAlert(backendMessage));
    yield put(setQuestionTemplateFormUpdateDataFail(error));
  }
}




export function* watchQuestions(){
    
    yield takeLatest(QUESTION_TEMPLATE_GET_DATA.QUESTION_TEMPLATE_GET_DATA_LOAD, getQuestionTemplateDataService);
    yield takeLatest(QUESTION_TEMPLATE_GET_DETAILS_DATA.QUESTION_TEMPLATE_GET_DETAILS_DATA_LOAD, getQuestionTemplateDetailsDataService);
    yield takeLatest(QUESTION_TEMPLATE_FORM_ADD_DATA.QUESTION_TEMPLATE_FORM_ADD_DATA_LOAD, postQuestionTemplateFormDataService);
    yield takeLatest(QUESTION_TEMPLATE_FORM_UPDATE_DATA.QUESTION_TEMPLATE_FORM_UPDATE_DATA_LOAD, putQuestionTemplateFormDataService);

}